import { createBodyToCheck, formatTasks } from '#helpers'
import axios from 'axios'
import applyCaseMiddleware from 'axios-case-converter'
import useSWR from 'swr'
const { baseURL, nonce, partnerKey, accessToken, uuid, pluginDir } =
  window.marketgoo

// TODO: Pending replace _marketgoo-development with variable
const description = `_${pluginDir}_${uuid}_description`
const keyword = `_${pluginDir}_${uuid}_keyword`
const keywordId = `_${pluginDir}_${uuid}_keywordId`
const score = `_${pluginDir}_${uuid}_score`

// TODO: Pending to remove selectors and implement it on usePost directly
export const selectors = {
  description,
  keyword,
  keywordId,
}

export const request = applyCaseMiddleware(
  axios.create({
    baseURL,
    headers: {
      [`${partnerKey}-authorization`]: `Bearer ${accessToken}`,
      'X-WP-Nonce': nonce || false,
    },
  }),
  {
    ignoreHeaders: true,
    preservedKeys: ['keywordId', description, keyword, keywordId, score],
  }
)

export const usePop = ({ id, type }) => {
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    id ? pop.get({ id, type }) : null,
    request
  )

  return {
    post: data?.data,
    isError: error,
    isLoading,
    mutate,
    isValidating,
  }
}

export const useTasks = ({ id, type }) => {
  const {
    data: post,
    isValidating: isPostValidating,
    mutate,
  } = useSWR(pop.get({ id, type }), request)

  const { data: check, isValidating: isCreateCheckValidating } = useSWR(
    post ? checks.create(createBodyToCheck(post)) : null,
    request
  )

  const {
    data,
    isLoading,
    isValidating: isCheckingValidating,
    error,
  } = useSWR(check ? checks.get(check.data.data.id) : null, request)

  const { isValidating: isScoreValidating } = useSWR(
    data
      ? meta.create({
          postId: id,
          data: { score: data?.data.data.attributes.score },
        })
      : null,
    request
  )
  const tasks = formatTasks(data?.data.data.attributes.tasks)

  return {
    tasks,
    isError: error,
    isLoading,
    mutate,
    isValidating:
      isPostValidating ||
      isCreateCheckValidating ||
      isCheckingValidating ||
      isScoreValidating,
  }
}

const GET = 'GET'
const POST = 'POST'

const checks = {
  create: (body) => ({
    url: `${partnerKey}/v1/checks`,
    method: POST,
    data: body,
  }),
  get: (id) => ({
    url: `${partnerKey}/v1/checks/${id}`,
    method: GET,
  }),
}

// keywords: caballo
const keywordSearch = {
  get: (keywords) => ({
    url: `${partnerKey}/v1/keyword-search`,
    method: POST,
    data: keywords,
  }),
}

const meta = {
  create: ({ postId, data }) => ({
    url: `${partnerKey}/v1/page/create/${postId}/meta`,
    method: POST,
    data,
  }),
}

const wpNS = '/wp/v2'
const popTypes = {
  page: 'pages',
  post: 'posts',
}

const posts = {
  get: (id) => ({
    url: id ? `${wpNS}/posts/${id}` : `${wpNS}/posts`,
    method: GET,
  }),
  edit: ({ postId, data } = {}) => ({
    url: `${wpNS}/posts/${postId}`,
    method: POST,
    data,
  }),
}

const pop = {
  get: ({ id, type }) => ({
    url: `${wpNS}/${popTypes[type]}/${id}`,
    method: GET,
  }),
  edit: ({ id, type, data } = {}) => ({
    url: `${wpNS}/${popTypes[type]}/${id}`,
    method: POST,
    data,
  }),
}

const pages = {
  get: (id) => ({
    url: id ? `${wpNS}/pages/${id}` : `${wpNS}/pages`,
    method: GET,
  }),
}

export const endpoints = {
  checks,
  keywordSearch,
  meta,
  pages,
  pop,
  posts,
}
